// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"0fb73c1d","105":"dc50f59b","327":"15e04ba3","344":"62da134f","472":"0648186f","490":"3ac1d527","496":"919155a5","565":"ae7fd9bf","574":"9727f727","580":"3019e3f4","678":"e1797cf1","860":"51179128","865":"aa257cf2","912":"387f27fd","945":"0c6d22a4"}[chunkId] + ".chunk.js";
};